svg{display:block;height:100%;width:100%}
/*# sourceMappingURL=cuboid-dimensions.component.css.map */
